import React from "react";

import { getTranslation } from "../../../helpers/getLanguage";
import styles from "./WarningDeleteComponentsAndAttributes.module.css";

export const WarningDeleteComponentsAndAttributes = ({ warningData, type }) => (
  <>
    <span className={styles.warningTitle}>
      {getTranslation(
        type === "single"
          ? "CONFIRM_MODAL_DELETE_ONE_COMPONENT_OR_ATTRIBUTE"
          : "CONFIRM_MODAL_DELETE_COMPONENTS_AND_ATTRIBUTES",
      )}
    </span>

    <span className={styles.warningText}>
      {getTranslation(
        type === "single" ? "CONFIRM_MODAL_WARNING_DELETE_COMPONENT" : "CONFIRM_MODAL_WARNING_DELETE_COMPONENTS",
      )}
    </span>

    <div className={styles.container}>
      {!!warningData?.componentsWithIdeas?.length && (
        <>
          <h6 className={styles.title}>
            {getTranslation(
              warningData.componentsWithIdeas.length === 1
                ? "WARNING_TITLE_FOR_ONE_COMPONENT"
                : "WARNING_TITLE_COMPONENTS",
            )}
          </h6>

          <div className={styles.listContainer}>
            <ul className={styles.list}>
              {warningData.componentsWithIdeas.map((row) => (
                <li key={row.id} className={`${styles.listItem} delete-selected-components_row sort-toggle`}>
                  {row.name}
                </li>
              ))}
            </ul>
          </div>
        </>
      )}

      {!!warningData?.attributesWithIdeas?.length && (
        <>
          <h6 className={styles.title}>
            {getTranslation(
              warningData.attributesWithIdeas.length === 1
                ? "WARNING_TITLE_FOR_ONE_ATTRIBUTE"
                : "WARNING_TITLE_ATTRIBUTES",
            )}
          </h6>

          <div className={styles.listContainer}>
            <ul className={styles.list}>
              {warningData.attributesWithIdeas.map((row) => (
                <li key={row.id} className={styles.listItem}>
                  {row.name} of {warningData.components.filter((component) => component.id === row.componentId)[0].name}
                </li>
              ))}
            </ul>
          </div>
        </>
      )}
    </div>
  </>
);
